<template>
    <div>
        <div class="image-editor-card-secondary gap-4 text-center h-100">
            <p class="fs-5 fw-600">{{$trans('storefront::image_editor.saved_drafts')}}</p>
            <p class="fs-6 text-muted fw-500" v-if="auth">{{$trans('storefront::image_editor.saved_drafts_description')}}</p>

            <div class="d-flex flex-column flex-sm-row justify-content-center mt-auto" v-if="auth" style="gap: 0.4rem 1rem;">
                <button type="button" class="btn btn-secondary btn-medium cursor-pointer" style="min-width: 150px" @click="$refs['draft-save-modal'].open()">{{$trans('storefront::image_editor.save')}}</button>
                <button type="button" class="btn btn-secondary btn-medium cursor-pointer" style="min-width: 150px" @click="$refs['draft-load-modal'].open()">{{$trans('storefront::image_editor.load')}}</button>
            </div>

            <p class="fs-6 text-muted fw-500 mt-auto" v-if="!auth">{{$trans('storefront::image_editor.you_must_be_logged_in_to_save_drafts')}}</p>

            <div class="d-flex justify-content-center" v-if="!auth">
                <a :href="route('login')" class="btn btn-secondary btn-medium cursor-pointer" style="min-width: 180px">{{$trans('storefront::image_editor.log_in')}}</a>
            </div>
        </div>

        <draft-load-modal ref="draft-load-modal"></draft-load-modal>
        <draft-save-modal ref="draft-save-modal"></draft-save-modal>
    </div>
</template>

<script>
import DraftLoadModal from "./DraftLoadModal";
import DraftSaveModal from "./DraftSaveModal";
import {useDraftStore} from "./store";

export default {
    components: {DraftSaveModal, DraftLoadModal},
    setup() {
        const store = useDraftStore();
        return {
            store,
            auth: window.auth,
        };
    },
}
</script>
